const genderFromJMBG = (value) => {
  if (!value) return null;
  const gender = value.substring(9, 12);
  return Number(gender) < 500 ? 'M' : 'Ž';
};

export default genderFromJMBG;
